import { useRef } from "react";
import { motion } from "framer-motion";
import useMotionPreferences from "@/hooks/useMotionPreferences";
import { EASING, DURATION } from "@/lib/motionSystem";

export default function TiltCard({
  children,
  className = "",
  maxTilt = 6,
  glow = false,
  ...props
}) {
  const ref = useRef(null);
  const { allowDecorativeEffects } = useMotionPreferences();

  const onMove = (event) => {
    if (!allowDecorativeEffects || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const px = (event.clientX - rect.left) / rect.width;
    const py = (event.clientY - rect.top) / rect.height;
    const tiltX = (0.5 - py) * maxTilt;
    const tiltY = (px - 0.5) * maxTilt;

    ref.current.style.transform = `perspective(900px) rotateX(${tiltX.toFixed(
      2,
    )}deg) rotateY(${tiltY.toFixed(2)}deg) translateZ(0)`;
  };

  const onLeave = () => {
    if (!ref.current) return;
    ref.current.style.transform = "";
  };

  return (
    <motion.div
      ref={ref}
      className={`transition-transform will-change-transform ${
        glow ? "hover:shadow-[0_0_24px_rgba(99,102,241,0.2)]" : ""
      } ${className}`}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      transition={{ duration: DURATION.hover, ease: EASING.standard }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
